// Account with data reminders
export const DATA_ACC_NAME = '🤖 [Endless Data]'

// Reminder payee names
export enum DataReminderType {
  GOALS = 'goals',
  ACC_LINKS = 'accLinks',
  TAG_ORDER = 'tagOrder',
  TAG_META = 'tagMeta',
}

export enum oldGoalType {
  MONTHLY = 'monthly', // monthly contribution
  MONTHLY_SPEND = 'monthlySpend', // monthly spend
  TARGET_BALANCE = 'targetBalance', //
}
